"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.PieceModelBuilder = exports.PieceModel = exports.PieceImage = exports.PieceWeight = exports.PieceConfiguration = exports.PieceSize = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var Design_1 = require("./Design");
var PieceSize;
(function (PieceSize) {
    PieceSize["SMALL"] = "SMALL";
    PieceSize["MEDIUM"] = "MEDIUM";
    PieceSize["LARGE"] = "LARGE";
})(PieceSize = exports.PieceSize || (exports.PieceSize = {}));
var PieceConfiguration = /** @class */ (function () {
    function PieceConfiguration() {
    }
    PieceConfiguration.getAvailableStonePlacementTypes = function (pieceConfigurations) {
        var stonesPlacementTypes = new Set();
        for (var _i = 0, pieceConfigurations_1 = pieceConfigurations; _i < pieceConfigurations_1.length; _i++) {
            var pc = pieceConfigurations_1[_i];
            stonesPlacementTypes.add(pc.stonesPlacementType);
        }
        return stonesPlacementTypes;
    };
    PieceConfiguration.getAvailablePlatingTypes = function (pieceConfigurations) {
        var platingTypes = new Set();
        for (var _i = 0, pieceConfigurations_2 = pieceConfigurations; _i < pieceConfigurations_2.length; _i++) {
            var pc = pieceConfigurations_2[_i];
            platingTypes.add(pc.platingType);
        }
        return platingTypes;
    };
    PieceConfiguration.getAvailableSizes = function (pieceConfigurations) {
        var pieceSizes = new Set();
        for (var _i = 0, pieceConfigurations_3 = pieceConfigurations; _i < pieceConfigurations_3.length; _i++) {
            var pc = pieceConfigurations_3[_i];
            pieceSizes.add(pc.sizeType);
        }
        return pieceSizes;
    };
    PieceConfiguration.getAvailableMaterialTypes = function (pieceConfigurations) {
        var materialTypes = new Set();
        for (var _i = 0, pieceConfigurations_4 = pieceConfigurations; _i < pieceConfigurations_4.length; _i++) {
            var pc = pieceConfigurations_4[_i];
            materialTypes.add(pc.materialType);
        }
        return materialTypes;
    };
    PieceConfiguration.identical = function (c1, c2) {
        return (c1.sizeType === c2.sizeType &&
            c1.materialType === c2.materialType &&
            c1.platingType === c2.platingType &&
            c1.stonesPlacementType === c2.stonesPlacementType);
    };
    PieceConfiguration.generatePieceAvailability = function (sizes, stones, materials, platings) {
        var result = [];
        sizes.forEach(function (sizeType) {
            stones.forEach(function (stone) {
                materials.forEach(function (material) {
                    platings.forEach(function (plating) {
                        result.push({
                            sizeType: sizeType,
                            stonesPlacementType: stone,
                            materialType: material,
                            platingType: plating
                        });
                    });
                });
            });
        });
        return result;
    };
    PieceConfiguration.fullPieceAvailability = PieceConfiguration.generatePieceAvailability([PieceSize.SMALL, PieceSize.MEDIUM, PieceSize.LARGE], [Design_1.StonesPlacementType.NO_STONES, Design_1.StonesPlacementType.FULL_STONES], [Design_1.MaterialType.SILVER], [Design_1.PlatingType.RHODIUM, Design_1.PlatingType.ROSE_GOLD, Design_1.PlatingType.YELLOW_GOLD]);
    return PieceConfiguration;
}());
exports.PieceConfiguration = PieceConfiguration;
var PieceWeight = /** @class */ (function () {
    function PieceWeight() {
    }
    PieceWeight.findPieceWeight = function (pieceWeights, matchPieceConfiguration) {
        return pieceWeights.find(function (p) { return PieceConfiguration.identical(p.configuration, matchPieceConfiguration); });
    };
    return PieceWeight;
}());
exports.PieceWeight = PieceWeight;
var PieceImage = /** @class */ (function () {
    function PieceImage() {
    }
    PieceImage.withImageUrl = function (oldPieceImage, newImageUrl) {
        return __assign(__assign({}, oldPieceImage), { image: core_common_domain_1.Image.withUrl(oldPieceImage.image, newImageUrl) });
    };
    PieceImage.findPieceImage = function (pieceImages, matchPieceConfiguration) {
        return pieceImages.find(function (p) { return PieceConfiguration.identical(p.configuration, matchPieceConfiguration); });
    };
    return PieceImage;
}());
exports.PieceImage = PieceImage;
var PieceModel = /** @class */ (function () {
    function PieceModel() {
    }
    PieceModel.isPublishable = function (pieceModel) {
        return (PieceModel.hasDimensionsValid(pieceModel) &&
            PieceModel.hasOutlineValid(pieceModel) &&
            PieceModel.hasIconValid(pieceModel) &&
            PieceModel.hasCadFileValid(pieceModel) &&
            PieceModel.hasEditableAreasValid(pieceModel) &&
            PieceModel.hasAvailableConfigurationsValid(pieceModel) &&
            PieceModel.hasWeightsValid(pieceModel) &&
            PieceModel.hasImagesValid(pieceModel));
    };
    PieceModel.isRenderable = function (pieceModel) {
        return (PieceModel.hasDimensionsValid(pieceModel) &&
            PieceModel.hasOutlineValid(pieceModel) &&
            PieceModel.hasIconValid(pieceModel) &&
            PieceModel.hasCadFileValid(pieceModel) &&
            PieceModel.hasEditableAreasValid(pieceModel) &&
            PieceModel.hasAvailableConfigurationsValid(pieceModel) &&
            PieceModel.hasWeightsValid(pieceModel));
    };
    PieceModel.hasDimensionsValid = function (pieceModel) {
        return core_common_domain_1.Dimensions3D.allDimensionsHigherThan(pieceModel.dimensions, 0);
    };
    PieceModel.hasOutlineValid = function (pieceModel) {
        if (escape.length === 0)
            return false;
        return pieceModel.editableSides.find(function (es) { return !Design_1.Shape.isValidDefined(es.shape); }) === undefined;
    };
    PieceModel.hasIconValid = function (pieceModel) {
        return core_common_domain_1.Media.isValidWithContentType(pieceModel.icon, core_common_domain_1.MimeType.SVG);
    };
    PieceModel.hasCadFileValid = function (pieceModel) {
        return core_common_domain_1.Media.isValidWithContentType(pieceModel.cadFile, core_common_domain_1.MimeType.GLB);
    };
    PieceModel.hasEditableAreasValid = function (pieceModel) {
        if (pieceModel.editableAreas.length === 0)
            return false;
        for (var _i = 0, _a = pieceModel.editableAreas; _i < _a.length; _i++) {
            var editableArea = _a[_i];
            if (!Design_1.Shape.isValidDefined(editableArea.shape))
                return false;
        }
        return true;
    };
    PieceModel.hasAvailableConfigurationsValid = function (pieceModel) {
        return pieceModel.availableConfigurations.length > 0;
    };
    PieceModel.hasWeightsValid = function (pieceModel) {
        var _loop_1 = function (availableConfig) {
            if (!pieceModel.weights.find(function (w) { return PieceConfiguration.identical(w.configuration, availableConfig); })) {
                return { value: false };
            }
        };
        /* Check 1 - Each available configuration must have an associated weight */
        for (var _i = 0, _a = pieceModel.availableConfigurations; _i < _a.length; _i++) {
            var availableConfig = _a[_i];
            var state_1 = _loop_1(availableConfig);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        /* Check 2 - Each weight must be a positive number */
        for (var _b = 0, _c = pieceModel.weights; _b < _c.length; _b++) {
            var weight = _c[_b];
            if (weight.weightInGrams <= 0)
                return false;
        }
        return true;
    };
    PieceModel.hasImagesValid = function (pieceModel) {
        var _loop_2 = function (availableConfig) {
            if (!pieceModel.images.find(function (i) { return PieceConfiguration.identical(i.configuration, availableConfig); })) {
                return { value: false };
            }
        };
        /* Check 1 - Each available configuration must have an associated image */
        for (var _i = 0, _a = pieceModel.availableConfigurations; _i < _a.length; _i++) {
            var availableConfig = _a[_i];
            var state_2 = _loop_2(availableConfig);
            if (typeof state_2 === "object")
                return state_2.value;
        }
        /* Check 2 - Each image must be a valid media */
        for (var _b = 0, _c = pieceModel.images; _b < _c.length; _b++) {
            var im = _c[_b];
            if (!core_common_domain_1.Media.isValidWithContentType(im.image.media, core_common_domain_1.MimeType.PNG))
                return false;
        }
        return true;
    };
    PieceModel.hasInconsistentState = function (pieceModel) {
        for (var _i = 0, _a = pieceModel.availableConfigurations; _i < _a.length; _i++) {
            var ac = _a[_i];
            if (ac.sizeType !== pieceModel.sizeType || ac.stonesPlacementType !== pieceModel.stonesPlacementType)
                return {
                    consistent: false,
                    reason: "Available configuration " + JSON.stringify(ac) + " must be consistent with the piece model " + JSON.stringify(pieceModel) + " => stonePlaceMentType must be " + pieceModel.stonesPlacementType + " and sizeType=" + pieceModel.sizeType
                };
        }
        for (var _b = 0, _c = pieceModel.images; _b < _c.length; _b++) {
            var ac = _c[_b];
            if (ac.configuration.sizeType !== pieceModel.sizeType ||
                ac.configuration.stonesPlacementType !== pieceModel.stonesPlacementType)
                return {
                    consistent: false,
                    reason: "Available images configuration " + JSON.stringify(ac) + " must be consistent with the piece model " + JSON.stringify(pieceModel) + " => stonePlaceMentType must be " + pieceModel.stonesPlacementType + " and sizeType=" + pieceModel.sizeType
                };
        }
        for (var _d = 0, _e = pieceModel.weights; _d < _e.length; _d++) {
            var ac = _e[_d];
            if (ac.configuration.sizeType !== pieceModel.sizeType ||
                ac.configuration.stonesPlacementType !== pieceModel.stonesPlacementType)
                return {
                    consistent: false,
                    reason: "Available weights configuration " + JSON.stringify(ac) + " must be consistent with the piece model " + JSON.stringify(pieceModel) + " => stonePlaceMentType must be " + pieceModel.stonesPlacementType + " and sizeType=" + pieceModel.sizeType
                };
        }
        return { consistent: true };
    };
    return PieceModel;
}());
exports.PieceModel = PieceModel;
var PieceModelBuilder = /** @class */ (function () {
    function PieceModelBuilder(pieceModel) {
        this.pieceModel = pieceModel;
    }
    PieceModelBuilder.initialiseWithPieceModel = function (pieceModel) {
        return new PieceModelBuilder(pieceModel);
    };
    PieceModelBuilder.initialiseWithPieceModelUpdate = function (update, pieceModelId) {
        return PieceModelBuilder.initialiseWithPieceModel({
            id: pieceModelId ? pieceModelId : core_common_logic_1.CommonLogic.generateUUIDv4(),
            editableAreas: update.editableAreas,
            editableSides: update.editableSides,
            stonesPlacementType: update.stonesPlacementType,
            cadFile: update.cadFile,
            sizeType: update.sizeType,
            dimensions: update.dimensions,
            icon: update.icon,
            availableConfigurations: update.availableConfigurations,
            weights: update.weights,
            images: update.images
        });
    };
    PieceModelBuilder.initialise = function (stonesPlacementType, sizeType, dimensions, availableConfigurations, weights) {
        return PieceModelBuilder.initialiseWithPieceModel({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            editableAreas: [],
            editableSides: [],
            stonesPlacementType: stonesPlacementType,
            cadFile: core_common_domain_1.Media.UNDEFINED,
            sizeType: sizeType,
            dimensions: dimensions,
            icon: core_common_domain_1.Media.UNDEFINED,
            availableConfigurations: availableConfigurations,
            weights: weights,
            images: []
        });
    };
    PieceModelBuilder.prototype.build = function () {
        return this.pieceModel;
    };
    PieceModelBuilder.prototype.buildUpdate = function () {
        return {
            editableAreas: this.pieceModel.editableAreas,
            editableSides: this.pieceModel.editableSides,
            stonesPlacementType: this.pieceModel.stonesPlacementType,
            cadFile: this.pieceModel.cadFile,
            sizeType: this.pieceModel.sizeType,
            dimensions: this.pieceModel.dimensions,
            icon: this.pieceModel.icon,
            availableConfigurations: this.pieceModel.availableConfigurations,
            weights: this.pieceModel.weights,
            images: this.pieceModel.images
        };
    };
    PieceModelBuilder.prototype.withId = function (pieceModelId) {
        this.pieceModel.id = pieceModelId;
        return this;
    };
    PieceModelBuilder.prototype.getId = function () {
        return this.pieceModel.id;
    };
    PieceModelBuilder.prototype.createOrReplacePieceImage = function (newPieceImage) {
        if (this.hasPieceImage(newPieceImage.configuration)) {
            return this.deletePieceImage(newPieceImage.configuration).createPieceImage(newPieceImage);
        }
        else {
            return this.createPieceImage(newPieceImage);
        }
    };
    PieceModelBuilder.prototype.hasPieceImage = function (pieceConfiguration) {
        return (this.pieceModel.images.find(function (image) {
            return PieceConfiguration.identical(image.configuration, pieceConfiguration);
        }) !== undefined);
    };
    PieceModelBuilder.prototype.createPieceImage = function (newPieceImage) {
        if (this.hasPieceImage(newPieceImage.configuration))
            throw new core_common_domain_1.Exception("Cannot update the piece model to add image with configuration " + newPieceImage.configuration + " because an image with an identican configuration is already inside the piece model " + this.getId());
        this.pieceModel.images.push(newPieceImage);
        return this;
    };
    PieceModelBuilder.prototype.deletePieceImage = function (pieceConfiguration) {
        if (!this.hasPieceImage(pieceConfiguration))
            throw new core_common_domain_1.Exception("Cannot update the piece model to remove image with configuration " + pieceConfiguration + " because it cannot be found inside the piece model " + this.getId());
        this.pieceModel.images = this.pieceModel.images.filter(function (image) { return !PieceConfiguration.identical(image.configuration, pieceConfiguration); });
        return this;
    };
    PieceModelBuilder.prototype.withPieceModelUpdate = function (pieceModelUpdate) {
        this.pieceModel = {
            id: this.pieceModel.id,
            editableAreas: pieceModelUpdate.editableAreas
                ? pieceModelUpdate.editableAreas
                : this.pieceModel.editableAreas,
            editableSides: pieceModelUpdate.editableSides
                ? pieceModelUpdate.editableSides
                : this.pieceModel.editableSides,
            stonesPlacementType: pieceModelUpdate.stonesPlacementType
                ? pieceModelUpdate.stonesPlacementType
                : this.pieceModel.stonesPlacementType,
            cadFile: pieceModelUpdate.cadFile ? pieceModelUpdate.cadFile : this.pieceModel.cadFile,
            sizeType: pieceModelUpdate.sizeType ? pieceModelUpdate.sizeType : this.pieceModel.sizeType,
            dimensions: pieceModelUpdate.dimensions ? pieceModelUpdate.dimensions : this.pieceModel.dimensions,
            icon: pieceModelUpdate.icon ? pieceModelUpdate.icon : this.pieceModel.icon,
            availableConfigurations: pieceModelUpdate.availableConfigurations
                ? pieceModelUpdate.availableConfigurations
                : this.pieceModel.availableConfigurations,
            weights: pieceModelUpdate.weights ? pieceModelUpdate.weights : this.pieceModel.weights,
            images: pieceModelUpdate.images ? pieceModelUpdate.images : this.pieceModel.images
        };
        return this;
    };
    return PieceModelBuilder;
}());
exports.PieceModelBuilder = PieceModelBuilder;
